import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Sidebar from './Sidebar';
import PageContent from './PageContent';
import ActionBarData from './ActionBarData';

const propTypes = {
  header: PropTypes.element.isRequired,
  leftSidebar: PropTypes.element,
  rightSidebar: PropTypes.element,
  actionBar: PropTypes.node,
  content: PropTypes.element.isRequired,
  footer: PropTypes.node,
  transparent: PropTypes.bool,
  showLeftSideBar: PropTypes.bool
};

function WrapperData({
  header,
  leftSidebar,
  actionBar,
  content,
  footer,
  rightSidebar,
  transparent,
  showLeftSideBar
}) {
  return (
    <div className="cData h-100">
        {header || ""}
        <div className='d-flex h-100'>
          {showLeftSideBar && leftSidebar}
          <PageContent
            actionBar={actionBar}
            footer={footer}
            transparent={transparent || false}
          >
            {content}
          </PageContent>
        </div>
        {rightSidebar}
    </div>
  );
}

WrapperData.propTypes = propTypes;
WrapperData.Header = Header;
WrapperData.Sidebar = Sidebar;
WrapperData.ActionBar = ActionBarData;

export default WrapperData;



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/WrapperData.js